module.exports = {"normal":"Normale","elite":"Élite","boss":"Boss","finalboss":"Boss finale","rare":"Raro"};